module.exports = __webpack_public_path__ + "img/bottom_right.b054b289.png";